import Content from '../../content.js';

namespace('IO.Views.Nodes', function (exports) {
  'use strict';

  var DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    New = Content.extend({
      dom: {
        SELECT2_FIELD: '.select2select',
        TYPE_OF_SERVER_SELECTOR: '.type-of-server-selector',
        NODES_FORM: '#regular-node-form',
        PUPPET_PROFILES: '.puppet_profiles_placeholder',
      },

      events: function () {
        var events = {};

        events['submit ' + this.dom.NODES_FORM] = '_beforeSave';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      afterRender: function () {
        var self = this,
          params;

        this.listenTo(this.dynamicForm, 'after:filter', this.checkRadioButtons);
        if (!_.isEmpty(location.hash)) {
          params = _.chain(
            location.hash.replace('#', '').replace('?', '').split('&'),
          )
            .map(function (urlParams) {
              var p = urlParams.split('=');

              return [p[0], decodeURIComponent(p[1])];
            })
            .object()
            .value();

          _.each(params, function (value, key) {
            self.$('#' + key).val(value);
          });
          location.hash = '';
        }
      },

      onDestroy: function () {
        this.dynamicForm.remove();
      },

      render: function () {
        this.puppetProfilesOrder = new PuppetProfilesOrder(this.$el);
        this.dynamicForm = new DynamicGroupForm({
          el: this.$el,
          formTarget: this.dom.NODES_FORM,
          radio: true,
        });
        this.dynamicForm.render();
        this.checkRadioButtons();
        this.initializeSelect2();
        this.$('td.radio').find('.unselect').hide();

        PropertyTypeMask.applyMasks.call(this);
        this.selectedPuppetModules = this._getSelectedPuppetModules();
      },

      _beforeSave: function () {
        if (!$(this.dom.NODES_FORM).hasClass('puppet-module-changes-yes')) {
          this._checkPuppetModuleChanges();
          return false;
        }

        return true;
      },

      initializeSelect2: function () {
        var $select = this.$(this.dom.SELECT2_FIELD);

        if (!$select.closest('.hide').length) {
          $select.select2({});
        }
      },

      _checkPuppetModuleChanges: function () {
        var self = this,
          proceed,
          newPuppetModules,
          addedModules,
          removedModules,
          puppetModuleChangesModal;

        proceed = function (shouldProceed) {
          if (shouldProceed) {
            $(self.dom.NODES_FORM).addClass('puppet-module-changes-yes');
            $(self.dom.NODES_FORM).submit();
          } else {
            $(self.dom.NODES_FORM).addClass('puppet-module-changes-no');
          }
        };

        newPuppetModules = this._getSelectedPuppetModules();

        if (
          $(this.selectedPuppetModules).not(newPuppetModules).length === 0 &&
          $(newPuppetModules).not(this.selectedPuppetModules).length === 0
        ) {
          proceed(true);
          return;
        }

        addedModules = $(newPuppetModules)
          .not(this.selectedPuppetModules)
          .get();
        removedModules = $(this.selectedPuppetModules)
          .not(newPuppetModules)
          .get();

        puppetModuleChangesModal = new IO.Views.NodeGroups.PuppetModuleChanges({
          wait: true,
        });
        puppetModuleChangesModal.setModuleChanges(
          'New node',
          addedModules,
          removedModules,
        );
        puppetModuleChangesModal.answer(function (shouldProceed) {
          proceed(shouldProceed);
          puppetModuleChangesModal.destroy();
        });
      },

      _getSelectedPuppetModules: function () {
        return $(this.dom.PUPPET_PROFILES + ' option:selected')
          .map(function () {
            return $(this).text();
          })
          .get();
      },
    });

  exports.New = New;
});
